{
  "familyId": "TAA-ONT-HOOFDZIN",
  "questions": [
    {
      "id": "TAA-ONT-HOOFDZIN-001",
      "familyId": "TAA-ONT-HOOFDZIN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_hoofdzin",
      "questionType": "multiple_choice",
      "question": "Hoeveel hoofdzinnen bevat deze zin? 'De zon schijnt en de vogels zingen.'",
      "options": ["2 hoofdzinnen", "1 hoofdzin", "3 hoofdzinnen", "0 hoofdzinnen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdzinnen herkennen", "content": "Een hoofdzin kan zelfstandig bestaan. Het voegwoord 'en' verbindt twee hoofdzinnen. Elke hoofdzin heeft een eigen persoonsvorm.", "icon": "lightbulb"}}],
      "conceptId": "hoofdzin_nevenschikking",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'De zon schijnt' is een hoofdzin (persoonsvorm: schijnt). 'De vogels zingen' is ook een hoofdzin (persoonsvorm: zingen). Het voegwoord 'en' verbindt ze. Dat heet nevenschikking.",
        "solutionSteps": ["Zoek de persoonsvormen: 'schijnt' en 'zingen'", "Elke persoonsvorm hoort bij een zin", "'De zon schijnt' = hoofdzin 1", "'de vogels zingen' = hoofdzin 2", "'en' = nevenschikkend voegwoord", "Antwoord: 2 hoofdzinnen"],
        "distractorExplanations": {
          "0": "Goed! Er zijn 2 hoofdzinnen, verbonden door het nevenschikkend voegwoord 'en'.",
          "1": "Je dacht waarschijnlijk dat het één lange zin is. Maar er zijn twee persoonsvormen ('schijnt' en 'zingen'), dus twee hoofdzinnen. Onthoud: elke persoonsvorm = een aparte zin.",
          "2": "Je dacht waarschijnlijk dat 'en' ook een aparte zin is. Maar 'en' is een voegwoord dat twee zinnen verbindt — het is zelf geen zin. Onthoud: voegwoorden verbinden, ze vormen geen eigen zin.",
          "3": "Je dacht waarschijnlijk dat dit geen hoofdzinnen zijn. Maar beide delen kunnen zelfstandig bestaan: 'De zon schijnt.' en 'De vogels zingen.' Onthoud: een hoofdzin kan op zichzelf staan."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.hoofdzin-een-lange-zin", "label": "Ziet samengestelde zin als één hoofdzin", "optionIndex": 1 },
          { "id": "taa.voegwoord-als-zin", "label": "Telt voegwoord als aparte zin", "optionIndex": 2 },
          { "id": "taa.hoofdzin-niet-herkend", "label": "Herkent hoofdzinnen niet als zelfstandig", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-HOOFDZIN-002",
      "familyId": "TAA-ONT-HOOFDZIN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_hoofdzin",
      "questionType": "multiple_choice",
      "question": "Welk voegwoord is nevenschikkend? 'Ik ga naar huis, want ik ben moe.'",
      "options": ["want", "omdat", "dat", "als"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Nevenschikkende voegwoorden", "content": "Nevenschikkende voegwoorden verbinden twee hoofdzinnen. Onthoud: en, of, maar, want, dus. Na een nevenschikkend voegwoord staat de persoonsvorm op de tweede plek.", "icon": "lightbulb"}}],
      "conceptId": "hoofdzin_voegwoord_nevenschikkend",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Want' is een nevenschikkend voegwoord. Het verbindt twee hoofdzinnen: 'Ik ga naar huis' en 'ik ben moe'. Na 'want' staat de persoonsvorm ('ben') op de tweede plek.",
        "solutionSteps": ["Nevenschikkende voegwoorden: en, of, maar, want, dus", "'want' staat in dit rijtje", "Na 'want': 'ik ben moe' → persoonsvorm op plek 2", "Antwoord: want"],
        "distractorExplanations": {
          "0": "Goed! 'Want' is nevenschikkend. Het verbindt twee hoofdzinnen.",
          "1": "Je dacht waarschijnlijk dat 'omdat' hetzelfde is als 'want'. Beide geven een reden, maar 'omdat' is onderschikkend (maakt een bijzin). Na 'omdat' staat de persoonsvorm achteraan. Onthoud: want = nevenschikkend, omdat = onderschikkend.",
          "2": "Je dacht waarschijnlijk dat 'dat' nevenschikkend is. Maar 'dat' is onderschikkend — het maakt een bijzin. Onthoud: nevenschikkend = en, of, maar, want, dus.",
          "3": "Je dacht waarschijnlijk dat 'als' nevenschikkend is. Maar 'als' is onderschikkend — het maakt een bijzin ('als ik moe ben'). Onthoud: na 'als' staat de persoonsvorm achteraan."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.want-omdat-verward", "label": "Verwart want (nevenschikkend) met omdat (onderschikkend)", "optionIndex": 1 },
          { "id": "taa.dat-nevenschikkend", "label": "Denkt dat 'dat' nevenschikkend is", "optionIndex": 2 },
          { "id": "taa.als-nevenschikkend", "label": "Denkt dat 'als' nevenschikkend is", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-HOOFDZIN-003",
      "familyId": "TAA-ONT-HOOFDZIN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_hoofdzin",
      "questionType": "multiple_choice",
      "question": "Welke zin bevat twee hoofdzinnen?",
      "options": ["Het regent, maar we gaan toch.", "Ik ga naar huis omdat het regent.", "De jongen die daar staat is mijn broer.", "Als het mooi weer is, gaan we zwemmen."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdzin of bijzin?", "content": "Een hoofdzin kan zelfstandig bestaan. Een bijzin begint met een onderschikkend voegwoord (omdat, dat, als, die, etc.) en kan NIET zelfstandig bestaan.", "icon": "lightbulb"}}],
      "conceptId": "hoofdzin_herkennen",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Het regent' en 'we gaan toch' zijn allebei hoofdzinnen — ze kunnen zelfstandig bestaan. 'Maar' is het nevenschikkend voegwoord. De andere zinnen bevatten bijzinnen (omdat, die, als).",
        "solutionSteps": ["Check elke zin op nevenschikkende voegwoorden", "'maar' = nevenschikkend → twee hoofdzinnen", "'omdat' = onderschikkend → hoofdzin + bijzin", "'die' = betrekkelijk → hoofdzin + bijzin", "'als' = onderschikkend → bijzin + hoofdzin"],
        "distractorExplanations": {
          "0": "Goed! 'Maar' verbindt twee hoofdzinnen: 'Het regent' en 'we gaan toch'.",
          "1": "Je dacht waarschijnlijk dat 'omdat' twee hoofdzinnen verbindt. Maar 'omdat' is onderschikkend — het maakt een bijzin. Onthoud: omdat, dat, als, die = bijzin.",
          "2": "Je dacht waarschijnlijk dat 'die' twee hoofdzinnen verbindt. Maar 'die daar staat' is een bijzin (betrekkelijke bijzin). Onthoud: 'die' en 'dat' als verwijswoord maken een bijzin.",
          "3": "Je dacht waarschijnlijk dat 'als' twee hoofdzinnen verbindt. Maar 'als het mooi weer is' is een bijzin. Onthoud: na 'als' staat de persoonsvorm achteraan = bijzin."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.omdat-twee-hoofdzinnen", "label": "Denkt dat 'omdat' twee hoofdzinnen verbindt", "optionIndex": 1 },
          { "id": "taa.die-twee-hoofdzinnen", "label": "Denkt dat 'die' twee hoofdzinnen verbindt", "optionIndex": 2 },
          { "id": "taa.als-twee-hoofdzinnen", "label": "Denkt dat 'als' twee hoofdzinnen verbindt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-HOOFDZIN-004",
      "familyId": "TAA-ONT-HOOFDZIN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_hoofdzin",
      "questionType": "multiple_choice",
      "question": "Wat is het verschil tussen een hoofdzin en een bijzin?",
      "options": ["Een hoofdzin kan zelfstandig bestaan, een bijzin niet.", "Een hoofdzin is altijd kort, een bijzin is lang.", "Een hoofdzin heeft geen persoonsvorm.", "Een bijzin staat altijd vooraan in de zin."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdzin vs bijzin", "content": "Een hoofdzin kan zelfstandig bestaan als complete zin. Een bijzin is afhankelijk van de hoofdzin en begint met een onderschikkend voegwoord.", "icon": "lightbulb"}}],
      "conceptId": "hoofdzin_vs_bijzin",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Het belangrijkste verschil: een hoofdzin kan op zichzelf staan als complete zin. Een bijzin is afhankelijk — 'omdat het regent' is geen complete zin. Beide hebben een persoonsvorm.",
        "solutionSteps": ["Hoofdzin: kan zelfstandig bestaan ('Het regent.')", "Bijzin: kan NIET zelfstandig bestaan ('omdat het regent')", "Beide hebben een persoonsvorm", "Lengte maakt niet uit"],
        "distractorExplanations": {
          "0": "Goed! Een hoofdzin kan zelfstandig bestaan, een bijzin niet.",
          "1": "Je dacht waarschijnlijk dat lengte het verschil is. Maar een hoofdzin kan lang zijn en een bijzin kort. Het gaat om zelfstandigheid, niet om lengte. Onthoud: kan de zin op zichzelf staan?",
          "2": "Je dacht waarschijnlijk dat een hoofdzin geen persoonsvorm heeft. Maar elke zin (hoofd- én bijzin) heeft een persoonsvorm. Onthoud: zonder persoonsvorm is het geen zin.",
          "3": "Je dacht waarschijnlijk dat een bijzin altijd vooraan staat. Maar een bijzin kan ook achteraan staan: 'Ik ga naar huis omdat het regent.' Onthoud: de positie maakt niet uit."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.hoofdzin-lengte-verschil", "label": "Denkt dat lengte het verschil bepaalt", "optionIndex": 1 },
          { "id": "taa.hoofdzin-geen-pv", "label": "Denkt dat hoofdzin geen persoonsvorm heeft", "optionIndex": 2 },
          { "id": "taa.bijzin-altijd-vooraan", "label": "Denkt dat bijzin altijd vooraan staat", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-HOOFDZIN-005",
      "familyId": "TAA-ONT-HOOFDZIN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_hoofdzin",
      "questionType": "matching",
      "question": "Koppel elk voegwoord aan het juiste type.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["en", "omdat", "maar", "dat"],
        "rightItems": ["nevenschikkend", "onderschikkend", "nevenschikkend", "onderschikkend"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Nevenschikkend of onderschikkend?", "content": "Nevenschikkend (verbindt hoofdzinnen): en, of, maar, want, dus. Onderschikkend (maakt bijzin): omdat, dat, als, die, toen, hoewel.", "icon": "lightbulb"}}],
      "conceptId": "hoofdzin_voegwoord_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'En' en 'maar' zijn nevenschikkend — ze verbinden twee hoofdzinnen. 'Omdat' en 'dat' zijn onderschikkend — ze maken een bijzin.",
        "solutionSteps": ["en → nevenschikkend (verbindt hoofdzinnen)", "omdat → onderschikkend (maakt bijzin)", "maar → nevenschikkend (verbindt hoofdzinnen)", "dat → onderschikkend (maakt bijzin)"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "TAA-ONT-HOOFDZIN-006",
      "familyId": "TAA-ONT-HOOFDZIN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_hoofdzin",
      "questionType": "drag_drop_fill",
      "question": "Sleep het juiste type voegwoord naar de lege plek in elke zin.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "template": "1. 'Ik ga naar huis want ik ben moe.' → Het voegwoord 'want' is {0}.\n\n2. 'Ik ga naar huis omdat ik moe ben.' → Het voegwoord 'omdat' is {1}.",
        "draggables": ["nevenschikkend", "onderschikkend"],
        "correctPlacements": {"0": 0, "1": 1}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nevenschikkend vs. onderschikkend",
            "content": "Nevenschikkend voegwoord (en, of, maar, want, dus): verbindt twee hoofdzinnen. Na het voegwoord staat de persoonsvorm op plek 2. Onderschikkend voegwoord (omdat, dat, als, die): maakt een bijzin. De persoonsvorm staat achteraan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoofdzin_voegwoord_drag_drop",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Want' is nevenschikkend: na 'want' staat de persoonsvorm ('ben') op plek 2 → 'ik ben moe'. 'Omdat' is onderschikkend: na 'omdat' staat de persoonsvorm ('ben') achteraan → 'ik moe ben'. Let op het verschil in woordvolgorde!",
        "solutionSteps": [
          "Zin 1: 'want ik ben moe' → persoonsvorm 'ben' op plek 2 → nevenschikkend",
          "Zin 2: 'omdat ik moe ben' → persoonsvorm 'ben' achteraan → onderschikkend",
          "Onthoud: nevenschikkend = pv op plek 2, onderschikkend = pv achteraan"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}